// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/poll_types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp.js";
import { SingleServiceAddressInfo } from "./address_types.js";

export const protobufPackage = "photon.imessage.v1";

/**
 * One option in a poll. `option_identifier` is Apple's stable opaque ID;
 * `creator_handle` is the participant who introduced the option (poll
 * creator for original options, voter address for added options).
 */
export interface PollOption {
  text: string;
  optionIdentifier: string;
  creatorHandle?: string | undefined;
}

/** One selected option in a participant's current vote snapshot. */
export interface PollParticipantVote {
  participant: SingleServiceAddressInfo | undefined;
  optionIdentifier: string;
}

/** Full poll snapshot. */
export interface PollInfo {
  pollMessageGuid: string;
  chatGuid: string;
  title: string;
  options: PollOption[];
  votes: PollParticipantVote[];
}

/**
 * Initial poll creation. `options` is the full option set as posted;
 * later additions arrive as `PollOptionAdded`.
 */
export interface PollCreated {
  title: string;
  options: PollOption[];
}

/**
 * New option appended to an existing poll. `options` is the *complete*
 * option set after insertion (not the delta) so consumers can replace
 * state directly.
 */
export interface PollOptionAdded {
  title: string;
  options: PollOption[];
}

/**
 * A participant voted for one option. The participant is carried by the
 * enclosing event actor.
 */
export interface PollVoted {
  optionIdentifier: string;
}

/**
 * A participant deselected one option. The participant is carried by the
 * enclosing event actor.
 */
export interface PollUnvoted {
  optionIdentifier: string;
}

/** A discrete state transition observed for a poll. */
export interface PollChangeEvent {
  chatGuid: string;
  pollMessageGuid: string;
  occurredAt: Date | undefined;
  actor?: SingleServiceAddressInfo | undefined;
  isFromMe: boolean;
  created?: PollCreated | undefined;
  optionAdded?: PollOptionAdded | undefined;
  voted?: PollVoted | undefined;
  unvoted?: PollUnvoted | undefined;
}

function createBasePollOption(): PollOption {
  return { text: "", optionIdentifier: "", creatorHandle: undefined };
}

export const PollOption: MessageFns<PollOption> = {
  encode(message: PollOption, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.optionIdentifier !== "") {
      writer.uint32(18).string(message.optionIdentifier);
    }
    if (message.creatorHandle !== undefined) {
      writer.uint32(26).string(message.creatorHandle);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PollOption {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePollOption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.optionIdentifier = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.creatorHandle = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PollOption {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      optionIdentifier: isSet(object.optionIdentifier)
        ? globalThis.String(object.optionIdentifier)
        : isSet(object.option_identifier)
        ? globalThis.String(object.option_identifier)
        : "",
      creatorHandle: isSet(object.creatorHandle)
        ? globalThis.String(object.creatorHandle)
        : isSet(object.creator_handle)
        ? globalThis.String(object.creator_handle)
        : undefined,
    };
  },

  toJSON(message: PollOption): unknown {
    const obj: any = {};
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.optionIdentifier !== "") {
      obj.optionIdentifier = message.optionIdentifier;
    }
    if (message.creatorHandle !== undefined) {
      obj.creatorHandle = message.creatorHandle;
    }
    return obj;
  },

  create(base?: DeepPartial<PollOption>): PollOption {
    return PollOption.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PollOption>): PollOption {
    const message = createBasePollOption();
    message.text = object.text ?? "";
    message.optionIdentifier = object.optionIdentifier ?? "";
    message.creatorHandle = object.creatorHandle ?? undefined;
    return message;
  },
};

function createBasePollParticipantVote(): PollParticipantVote {
  return { participant: undefined, optionIdentifier: "" };
}

export const PollParticipantVote: MessageFns<PollParticipantVote> = {
  encode(message: PollParticipantVote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.participant !== undefined) {
      SingleServiceAddressInfo.encode(message.participant, writer.uint32(10).fork()).join();
    }
    if (message.optionIdentifier !== "") {
      writer.uint32(18).string(message.optionIdentifier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PollParticipantVote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePollParticipantVote();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.participant = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.optionIdentifier = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PollParticipantVote {
    return {
      participant: isSet(object.participant) ? SingleServiceAddressInfo.fromJSON(object.participant) : undefined,
      optionIdentifier: isSet(object.optionIdentifier)
        ? globalThis.String(object.optionIdentifier)
        : isSet(object.option_identifier)
        ? globalThis.String(object.option_identifier)
        : "",
    };
  },

  toJSON(message: PollParticipantVote): unknown {
    const obj: any = {};
    if (message.participant !== undefined) {
      obj.participant = SingleServiceAddressInfo.toJSON(message.participant);
    }
    if (message.optionIdentifier !== "") {
      obj.optionIdentifier = message.optionIdentifier;
    }
    return obj;
  },

  create(base?: DeepPartial<PollParticipantVote>): PollParticipantVote {
    return PollParticipantVote.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PollParticipantVote>): PollParticipantVote {
    const message = createBasePollParticipantVote();
    message.participant = (object.participant !== undefined && object.participant !== null)
      ? SingleServiceAddressInfo.fromPartial(object.participant)
      : undefined;
    message.optionIdentifier = object.optionIdentifier ?? "";
    return message;
  },
};

function createBasePollInfo(): PollInfo {
  return { pollMessageGuid: "", chatGuid: "", title: "", options: [], votes: [] };
}

export const PollInfo: MessageFns<PollInfo> = {
  encode(message: PollInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pollMessageGuid !== "") {
      writer.uint32(10).string(message.pollMessageGuid);
    }
    if (message.chatGuid !== "") {
      writer.uint32(18).string(message.chatGuid);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    for (const v of message.options) {
      PollOption.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.votes) {
      PollParticipantVote.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PollInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePollInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pollMessageGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.options.push(PollOption.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.votes.push(PollParticipantVote.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PollInfo {
    return {
      pollMessageGuid: isSet(object.pollMessageGuid)
        ? globalThis.String(object.pollMessageGuid)
        : isSet(object.poll_message_guid)
        ? globalThis.String(object.poll_message_guid)
        : "",
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      options: globalThis.Array.isArray(object?.options) ? object.options.map((e: any) => PollOption.fromJSON(e)) : [],
      votes: globalThis.Array.isArray(object?.votes)
        ? object.votes.map((e: any) => PollParticipantVote.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PollInfo): unknown {
    const obj: any = {};
    if (message.pollMessageGuid !== "") {
      obj.pollMessageGuid = message.pollMessageGuid;
    }
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.options?.length) {
      obj.options = message.options.map((e) => PollOption.toJSON(e));
    }
    if (message.votes?.length) {
      obj.votes = message.votes.map((e) => PollParticipantVote.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<PollInfo>): PollInfo {
    return PollInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PollInfo>): PollInfo {
    const message = createBasePollInfo();
    message.pollMessageGuid = object.pollMessageGuid ?? "";
    message.chatGuid = object.chatGuid ?? "";
    message.title = object.title ?? "";
    message.options = object.options?.map((e) => PollOption.fromPartial(e)) || [];
    message.votes = object.votes?.map((e) => PollParticipantVote.fromPartial(e)) || [];
    return message;
  },
};

function createBasePollCreated(): PollCreated {
  return { title: "", options: [] };
}

export const PollCreated: MessageFns<PollCreated> = {
  encode(message: PollCreated, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    for (const v of message.options) {
      PollOption.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PollCreated {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePollCreated();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.options.push(PollOption.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PollCreated {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      options: globalThis.Array.isArray(object?.options) ? object.options.map((e: any) => PollOption.fromJSON(e)) : [],
    };
  },

  toJSON(message: PollCreated): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.options?.length) {
      obj.options = message.options.map((e) => PollOption.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<PollCreated>): PollCreated {
    return PollCreated.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PollCreated>): PollCreated {
    const message = createBasePollCreated();
    message.title = object.title ?? "";
    message.options = object.options?.map((e) => PollOption.fromPartial(e)) || [];
    return message;
  },
};

function createBasePollOptionAdded(): PollOptionAdded {
  return { title: "", options: [] };
}

export const PollOptionAdded: MessageFns<PollOptionAdded> = {
  encode(message: PollOptionAdded, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    for (const v of message.options) {
      PollOption.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PollOptionAdded {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePollOptionAdded();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.options.push(PollOption.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PollOptionAdded {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      options: globalThis.Array.isArray(object?.options) ? object.options.map((e: any) => PollOption.fromJSON(e)) : [],
    };
  },

  toJSON(message: PollOptionAdded): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.options?.length) {
      obj.options = message.options.map((e) => PollOption.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<PollOptionAdded>): PollOptionAdded {
    return PollOptionAdded.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PollOptionAdded>): PollOptionAdded {
    const message = createBasePollOptionAdded();
    message.title = object.title ?? "";
    message.options = object.options?.map((e) => PollOption.fromPartial(e)) || [];
    return message;
  },
};

function createBasePollVoted(): PollVoted {
  return { optionIdentifier: "" };
}

export const PollVoted: MessageFns<PollVoted> = {
  encode(message: PollVoted, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.optionIdentifier !== "") {
      writer.uint32(10).string(message.optionIdentifier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PollVoted {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePollVoted();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.optionIdentifier = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PollVoted {
    return {
      optionIdentifier: isSet(object.optionIdentifier)
        ? globalThis.String(object.optionIdentifier)
        : isSet(object.option_identifier)
        ? globalThis.String(object.option_identifier)
        : "",
    };
  },

  toJSON(message: PollVoted): unknown {
    const obj: any = {};
    if (message.optionIdentifier !== "") {
      obj.optionIdentifier = message.optionIdentifier;
    }
    return obj;
  },

  create(base?: DeepPartial<PollVoted>): PollVoted {
    return PollVoted.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PollVoted>): PollVoted {
    const message = createBasePollVoted();
    message.optionIdentifier = object.optionIdentifier ?? "";
    return message;
  },
};

function createBasePollUnvoted(): PollUnvoted {
  return { optionIdentifier: "" };
}

export const PollUnvoted: MessageFns<PollUnvoted> = {
  encode(message: PollUnvoted, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.optionIdentifier !== "") {
      writer.uint32(10).string(message.optionIdentifier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PollUnvoted {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePollUnvoted();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.optionIdentifier = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PollUnvoted {
    return {
      optionIdentifier: isSet(object.optionIdentifier)
        ? globalThis.String(object.optionIdentifier)
        : isSet(object.option_identifier)
        ? globalThis.String(object.option_identifier)
        : "",
    };
  },

  toJSON(message: PollUnvoted): unknown {
    const obj: any = {};
    if (message.optionIdentifier !== "") {
      obj.optionIdentifier = message.optionIdentifier;
    }
    return obj;
  },

  create(base?: DeepPartial<PollUnvoted>): PollUnvoted {
    return PollUnvoted.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PollUnvoted>): PollUnvoted {
    const message = createBasePollUnvoted();
    message.optionIdentifier = object.optionIdentifier ?? "";
    return message;
  },
};

function createBasePollChangeEvent(): PollChangeEvent {
  return {
    chatGuid: "",
    pollMessageGuid: "",
    occurredAt: undefined,
    actor: undefined,
    isFromMe: false,
    created: undefined,
    optionAdded: undefined,
    voted: undefined,
    unvoted: undefined,
  };
}

export const PollChangeEvent: MessageFns<PollChangeEvent> = {
  encode(message: PollChangeEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.pollMessageGuid !== "") {
      writer.uint32(18).string(message.pollMessageGuid);
    }
    if (message.occurredAt !== undefined) {
      Timestamp.encode(toTimestamp(message.occurredAt), writer.uint32(26).fork()).join();
    }
    if (message.actor !== undefined) {
      SingleServiceAddressInfo.encode(message.actor, writer.uint32(34).fork()).join();
    }
    if (message.isFromMe !== false) {
      writer.uint32(40).bool(message.isFromMe);
    }
    if (message.created !== undefined) {
      PollCreated.encode(message.created, writer.uint32(82).fork()).join();
    }
    if (message.optionAdded !== undefined) {
      PollOptionAdded.encode(message.optionAdded, writer.uint32(90).fork()).join();
    }
    if (message.voted !== undefined) {
      PollVoted.encode(message.voted, writer.uint32(98).fork()).join();
    }
    if (message.unvoted !== undefined) {
      PollUnvoted.encode(message.unvoted, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PollChangeEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePollChangeEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pollMessageGuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.occurredAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.actor = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isFromMe = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.created = PollCreated.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.optionAdded = PollOptionAdded.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.voted = PollVoted.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.unvoted = PollUnvoted.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PollChangeEvent {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      pollMessageGuid: isSet(object.pollMessageGuid)
        ? globalThis.String(object.pollMessageGuid)
        : isSet(object.poll_message_guid)
        ? globalThis.String(object.poll_message_guid)
        : "",
      occurredAt: isSet(object.occurredAt)
        ? fromJsonTimestamp(object.occurredAt)
        : isSet(object.occurred_at)
        ? fromJsonTimestamp(object.occurred_at)
        : undefined,
      actor: isSet(object.actor) ? SingleServiceAddressInfo.fromJSON(object.actor) : undefined,
      isFromMe: isSet(object.isFromMe)
        ? globalThis.Boolean(object.isFromMe)
        : isSet(object.is_from_me)
        ? globalThis.Boolean(object.is_from_me)
        : false,
      created: isSet(object.created) ? PollCreated.fromJSON(object.created) : undefined,
      optionAdded: isSet(object.optionAdded)
        ? PollOptionAdded.fromJSON(object.optionAdded)
        : isSet(object.option_added)
        ? PollOptionAdded.fromJSON(object.option_added)
        : undefined,
      voted: isSet(object.voted) ? PollVoted.fromJSON(object.voted) : undefined,
      unvoted: isSet(object.unvoted) ? PollUnvoted.fromJSON(object.unvoted) : undefined,
    };
  },

  toJSON(message: PollChangeEvent): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.pollMessageGuid !== "") {
      obj.pollMessageGuid = message.pollMessageGuid;
    }
    if (message.occurredAt !== undefined) {
      obj.occurredAt = message.occurredAt.toISOString();
    }
    if (message.actor !== undefined) {
      obj.actor = SingleServiceAddressInfo.toJSON(message.actor);
    }
    if (message.isFromMe !== false) {
      obj.isFromMe = message.isFromMe;
    }
    if (message.created !== undefined) {
      obj.created = PollCreated.toJSON(message.created);
    }
    if (message.optionAdded !== undefined) {
      obj.optionAdded = PollOptionAdded.toJSON(message.optionAdded);
    }
    if (message.voted !== undefined) {
      obj.voted = PollVoted.toJSON(message.voted);
    }
    if (message.unvoted !== undefined) {
      obj.unvoted = PollUnvoted.toJSON(message.unvoted);
    }
    return obj;
  },

  create(base?: DeepPartial<PollChangeEvent>): PollChangeEvent {
    return PollChangeEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PollChangeEvent>): PollChangeEvent {
    const message = createBasePollChangeEvent();
    message.chatGuid = object.chatGuid ?? "";
    message.pollMessageGuid = object.pollMessageGuid ?? "";
    message.occurredAt = object.occurredAt ?? undefined;
    message.actor = (object.actor !== undefined && object.actor !== null)
      ? SingleServiceAddressInfo.fromPartial(object.actor)
      : undefined;
    message.isFromMe = object.isFromMe ?? false;
    message.created = (object.created !== undefined && object.created !== null)
      ? PollCreated.fromPartial(object.created)
      : undefined;
    message.optionAdded = (object.optionAdded !== undefined && object.optionAdded !== null)
      ? PollOptionAdded.fromPartial(object.optionAdded)
      : undefined;
    message.voted = (object.voted !== undefined && object.voted !== null)
      ? PollVoted.fromPartial(object.voted)
      : undefined;
    message.unvoted = (object.unvoted !== undefined && object.unvoted !== null)
      ? PollUnvoted.fromPartial(object.unvoted)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
